import * as S from './styles'
import { DefexContent, DefexMenu } from '../../Molecules'

const Defex = () => {
  return (
    <S.DefexStyled>
      <DefexMenu />
      <DefexContent />
    </S.DefexStyled>
  )
}

export default Defex
